import { FEATURE_FLAG_CUSTOMER_IDS, FEATURE_FLAGS } from './constants';
import type { FeatureFlag, FeatureFlagConfiguration } from './types';

export const FEATURE_FLAG_CONFIGURATIONS: Record<
  FeatureFlag,
  FeatureFlagConfiguration
> = {
  [FEATURE_FLAGS.GLOBAL_ERROR_MESSAGE]: {
    prod: false,
    dev: false,
    local: true,
    overrideEnabledForCustomerIds: [
      FEATURE_FLAG_CUSTOMER_IDS.BATALJONEN_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.CX_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.PIGELLO_DEMO_PROD,
    ],
  },
  [FEATURE_FLAGS.DISCONNECT_PAYMENT]: {
    prod: false,
    dev: false,
    local: true,
    overrideEnabledForCustomerIds: [
      FEATURE_FLAG_CUSTOMER_IDS.BATALJONEN_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.CX_DEMO,
    ],
  },
  [FEATURE_FLAGS.BRF_REPORTS]: {
    prod: false,
    dev: true,
    local: true,
    overrideEnabledForCustomerIds: [
      FEATURE_FLAG_CUSTOMER_IDS.BATALJONEN_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.CX_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.ASPELIN_RAMM_PROD,
      FEATURE_FLAG_CUSTOMER_IDS.SWEAX_PROD,
      FEATURE_FLAG_CUSTOMER_IDS.OBOS_PROD,
      FEATURE_FLAG_CUSTOMER_IDS.HEMMAVID_PROD,
    ],
  },
  [FEATURE_FLAGS.PAYMENT_REPORTS]: {
    prod: false,
    dev: true,
    local: true,
  },
  [FEATURE_FLAGS.CHRISTMAS_MODE]: {
    // enable for christmas joy
    prod: false,
    dev: false,
    local: false,
  },
  [FEATURE_FLAGS.MARKET]: {
    prod: false,
    dev: false,
    local: true,
    overrideEnabledForCustomerIds: [
      FEATURE_FLAG_CUSTOMER_IDS.CX_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.BATALJONEN_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.STENA_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.UPPSALA_TEST_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.UPPSALA_PROD,
      FEATURE_FLAG_CUSTOMER_IDS.PIGELLO_DEMO_PROD,
      FEATURE_FLAG_CUSTOMER_IDS.UPPSALA_TEST_2_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.RONNEBYHUS_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.KARLSBORG_PROD,
      FEATURE_FLAG_CUSTOMER_IDS.LINDA_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.SVEAVIKEN_TEST_PROD,
      FEATURE_FLAG_CUSTOMER_IDS.SVEAVIKEN_SKARP_PROD,
    ],
  },
  [FEATURE_FLAGS.CHAT_WIDGET]: {
    prod: false,
    dev: false,
    local: true,
    overrideEnabledForCustomerIds: [
      FEATURE_FLAG_CUSTOMER_IDS.STENA_PROD,
      FEATURE_FLAG_CUSTOMER_IDS.CX_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.BATALJONEN_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.PIGELLO_DEMO_PROD,
    ],
  },
  [FEATURE_FLAGS.MICROSOFT_BOOKINGS]: {
    prod: false,
    dev: false,
    local: true,
    overrideEnabledForCustomerIds: [
      FEATURE_FLAG_CUSTOMER_IDS.BATALJONEN_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.CX_DEMO,
      FEATURE_FLAG_CUSTOMER_IDS.PIGELLO_DEMO_PROD,
    ],
  },
} as const;
